/**
 * Sorts array ascending, does not modify original array passed to it!
 * @param {Object[]} arr Array of objects to be sorted
 * @param {string} field Name of the field in the objects to be sorted
 * @returns Sorted array
 */

const sortBy = (arr, field, order = "ASC") =>
  [...arr].sort((item1, item2) => {
    if (!(field in item1) || !(field in item2)) {
      return 0
    }

    if (item1[field] > item2[field]) {
      return order === "ASC" ? 1 : -1
    }

    if (item1[field] < item2[field]) {
      return order === "ASC" ? -1 : 1
    }

    return 0
  })

module.exports = sortBy
